import { useId } from 'react'

import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Loading SVG Icon for loading spinner.
 */
export const LoadingSVG: React.FC<AccessibleSVGProps> = (props) => {
  const clipPathId = useId()

  return (
    <AccessibleSVG width={25} height={24} fill="none" {...props}>
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fill="#424242"
          d="M12.394 24c-1.62 0-3.192-.316-4.67-.942a11.961 11.961 0 0 1-3.814-2.574 11.96 11.96 0 0 1-2.574-3.813A11.924 11.924 0 0 1 .394 12a.843.843 0 1 1 1.688 0 10.297 10.297 0 0 0 3.021 7.294 10.26 10.26 0 0 0 7.291 3.018 10.295 10.295 0 0 0 7.294-3.021A10.26 10.26 0 0 0 22.707 12c0-1.392-.272-2.742-.811-4.015a10.324 10.324 0 0 0-2.21-3.279 10.26 10.26 0 0 0-7.292-3.019.843.843 0 1 1 0-1.687c1.62 0 3.192.316 4.671.942a11.96 11.96 0 0 1 3.814 2.574 11.98 11.98 0 0 1 2.57 3.813c.627 1.479.943 3.051.943 4.671s-.316 3.192-.942 4.671a11.917 11.917 0 0 1-2.571 3.813A11.981 11.981 0 0 1 12.394 24Z"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="#fff" d="M.394 0h24v24h-24z" />
        </clipPath>
      </defs>
    </AccessibleSVG>
  )
}
